import {Injectable, OnDestroy} from '@angular/core';
import {CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {AppService} from 'app/services/app.service';
import {HelperService} from 'app/services/helper.service';
import {NavigationService} from 'app/services/navigation.service';
import {UserModelService} from 'app/models/user-model.service';
import {AuthenticationService} from 'app/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginPhoneGuard implements CanActivateChild {
  appService: AppService;
  authenticationService: AuthenticationService;
  navigationService: NavigationService;

  constructor(
    appService: AppService,
    authenticationService: AuthenticationService,
    navigationService: NavigationService,
  ) {
    this.appService = appService;
    this.authenticationService = authenticationService;
    this.navigationService = navigationService;
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean | UrlTree> {

    if (this.authenticationService.userPhone === null) {
      this.navigationService.goTo('authentication/phone');
      return false;
    }

    return true;
  }

}
